export const RANGE_MIN_VALUE = 0;

export const RANGE_MAX_VALUE = 100;

export const FILTER_UPDATE_DEBOUNCE = 1000;

export const DEFAULT_BAR_WIDTH = 8;

export const DEFAULT_BAR_PADDING = 1;

export const DEFAULT_BAR_CHART_HEIGHT = 100;

export const BAR_CHART_HEADER_HEIGHT = 40;

export const BAR_CHART_FOOTER_MARGIN = 16;

export const DEFAULT_BAR_CHART_MARGINS = {
  top: 0,
  left: 0,
  bottom: 20,
  right: 0,
};
